import React from "react";
import { dispatch } from "@rematch/core";
import _ from "lodash";
import { Form } from "formsy-semantic-ui-react";
import LoadingComponent from "../../../../common/LoadingComponent";
import { toastr } from 'react-redux-toastr';
import ShowFieldMappingScenarioInputs from "../../drive/modals/ShowFieldMappingScenarioInputs";
import { Popup } from 'semantic-ui-react';


import {
  Input,
  Button,
  Header,
  Modal,
  Message,
  Grid,
  Checkbox
} from "semantic-ui-react";

let FieldMap = require('../../../../../images/common/field-mapping-icon.svg');

class ShowScenarioInputs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isJSONValid: true,
      updatedMetaDataSchema: this.props.metaDataSchema,
      loader: false,
      selectedScenarioInputs: [],
      selectedScenarioInput: {},
      dummyFlag: false,
      scenarioFieldMappingInputsModalFlag: false,
      validationErrors: {},
    };
  }

  componentDidMount() {
    this.initializeScenarioInputs();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.initializeScenarioInputs();
    }
  }

  initializeScenarioInputs = () => {
    if (this.props.selectedScenarioInputs && this.props.selectedScenarioInputs.length > 0) {
      const initialInputs = this.props.selectedScenarioInputs.map(input => ({
        ...input,
        checked: input.checked || false,
        default: input.default || '',
        query: input.query || ''
      }));
      
      this.setState({
        selectedScenarioInputs: initialInputs
      });
    }
  };

  close = () => {
    this.setState({
      isJSONValid: true,
      updatedMetaDataSchema: this.props.metaDataSchema,
      loader: false,
      selectedScenarioInputs: [],
      selectedScenarioInput: {},
      dummyFlag: false,
      scenarioFieldMappingInputsModalFlag: false,
      validationErrors: {},
    });
    this.props.close();
  };

  onChangeValue = (event, input) => {
    const newValue = event.target.value;
    const updatedScenarioInputs = this.state.selectedScenarioInputs.map((scenarioInput) => {
      if (scenarioInput.name === input.name) {
        return { ...scenarioInput, default: newValue };
      }
      return scenarioInput;
    });
    const updatedValidationErrors = { ...this.state.validationErrors };
    delete updatedValidationErrors[input.name];
    this.setState({ 
      selectedScenarioInputs: updatedScenarioInputs,
      validationErrors: updatedValidationErrors
    });
  };

  enableFieldMapping = (e, field) => {
    const updatedScenarioInputs = this.state.selectedScenarioInputs.map((input) => {
      if (input.name === field.name) {
        const updatedInput = { ...input, checked: !input.checked };
        if (!updatedInput.checked) {
          delete updatedInput.collection;
          delete updatedInput.query;
        }
        return updatedInput;
      }
      return input;
    });

    const updatedErrors = { ...this.state.validationErrors };
    if (!field.checked) {
      delete updatedErrors[field.name];
    }

    this.setState({
      selectedScenarioInputs: updatedScenarioInputs,
      validationErrors: updatedErrors,
    });
  };

  saveScenarioInputs = async () => {
    const validationErrors = {};
    let hasError = false;

    this.state.selectedScenarioInputs.forEach((input) => {
      if (input.required) {
        if (!input.checked && !input.default) {
          validationErrors[input.name] = 'This field is required';
          hasError = true;
        } else if (input.checked && !input.query) {
          validationErrors[input.name] = 'Field mapping is required';
          hasError = true;
        }
      }
    });

    if (hasError) {
      this.setState({ validationErrors });
      return;
    }

    let payload = this.props.selectedActivityAction;
    payload.metaData.scenarioInputs = this.state.selectedScenarioInputs;
    this.props.close();
    await dispatch.lifeCycle.updateActivityActions(payload);
    toastr.success('Message', `Scenario inputs updated successfully`);
  };

  openFieldMappingModal = (input) => {
    this.setState({selectedScenarioInput: input});
    this.manageFieldMappingScenarioInputModal(true);
  };

  closeFieldMappingModal = () => {
    const input = this.state.selectedScenarioInput;
    if (input && input.query) {
      const updatedErrors = { ...this.state.validationErrors };
      delete updatedErrors[input.name];
      this.setState({ validationErrors: updatedErrors });
    }
    this.manageFieldMappingScenarioInputModal(false);
  };

  manageFieldMappingScenarioInputModal = (modalFlag) => {
    this.setState({scenarioFieldMappingInputsModalFlag: modalFlag});
  };

  render() {
    const { selectedScenarioInputs, validationErrors } = this.state;
    return (
      <div>
        <Modal
          open={this.props.open}
          onClose={this.close}
          size="small"
          closeOnEscape={false}
          closeOnDimmerClick={false}
        >
          <Header content="Manage Scenario Input" />
          <Modal.Content style={{padding: '0.5rem'}}>
            {selectedScenarioInputs.length > 0 ? (
              <Grid>
                <Grid.Row style={{paddingTop: '0.5rem', paddingBottom: '0.5rem'}}>
                  <Grid.Column width={5}>
                    <div className='acc-header'>Input</div>
                  </Grid.Column>
                  <Grid.Column width={4} style={{ textAlign: "center"}}>
                    <div className='acc-header'>Map field</div>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <div className='acc-header'>Value</div>
                  </Grid.Column>
                </Grid.Row>
                {selectedScenarioInputs.map((input, index) => (
                  <Grid.Row key={index} style={{ marginBottom: '5px', paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
                    <Grid.Column width={5}>
                      <Input style={{ width: "200px", 'pointer-events': 'none' }} disabled placeholder="Name" value={input.name} />
                    </Grid.Column>
                    <Grid.Column style={{ textAlign: "center"}} width={4}>
                      <Checkbox
                        style={{ marginTop: '5px'}}
                        toggle
                        checked={input.checked}
                        onChange={(e) => this.enableFieldMapping(e, input)}
                      />
                    </Grid.Column>
                    <Grid.Column width={6} style={{ display: 'flex', alignItems: 'center' }}>
                      <div>
                        <div>
                          <Input
                            style={{
                              width: "200px",
                              border: validationErrors[input.name] ? '1px solid red' : null,
                              borderRadius: '4px'
                            }}
                            onChange={(e) => this.onChangeValue(e, input)}
                            placeholder="Value"
                            disabled={(input.query || input.checked) ? true : false}
                            value={input.query ? input.query : (input.checked && !input.query)? "map value" : input.default}
                          />
                          {input.checked && 
                            <Popup
                              content="Field Mapping"
                              className="cursor-pointer popupStyled"
                              inverted
                              trigger={
                                <span className='cursor-pointer' style={{ marginLeft: '5px'}} onClick={() => this.openFieldMappingModal(input)}>
                                  <img 
                                    src={FieldMap}
                                    alt="mapping"
                                    width="16"
                                    height="16"
                                  />
                                </span>
                              }
                              position="top left"
                              size="tiny"
                            />
                          }
                        </div>
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                ))}
              </Grid>
            ) : "No scenario input is added to this scenario"}
          </Modal.Content>
          <Modal.Actions>
            <Button
              className="button-cancel"
              id="cancelSchema"
              onClick={this.close}
            >
              Close
            </Button>
            {selectedScenarioInputs.length > 0 && (
              <Button
                className="button-submit"
                id="cancelSchema"
                onClick={this.saveScenarioInputs}
              >
                Save
              </Button>
            )}
          </Modal.Actions>
        </Modal>
        {this.state.scenarioFieldMappingInputsModalFlag && (
          <ShowFieldMappingScenarioInputs
            open={this.state.scenarioFieldMappingInputsModalFlag}
            close={this.closeFieldMappingModal}
            selectedScenarioInput={this.state.selectedScenarioInput}
            entities={this.props.entities}
            entityFieldMapping={this.props.entityFieldMapping}
            organizationId={this.props.organizationId}
            teamList={this.props.teamList}
          />
        )}
      </div>
    );
  }
}

export default ShowScenarioInputs;
